// Makes an element that isn't a button (a link with no address, an icon picture) work like one from the keyboard: a Tab
// stop, the button role for screen readers, and Enter or Space to press it. Used by the game screens' top bar and the
// student cards, whose styles (shared by all the games) target these elements by tag, so they keep their look.
export const pressable = (onPress, { label, disabled = false, expanded, pressed } = {}) => ({
    role: 'button',
    tabIndex: disabled ? -1 : 0,
    'aria-label': label,
    'aria-disabled': disabled ? 'true' : undefined,
    'aria-expanded': expanded === undefined ? undefined : !!expanded,
    'aria-pressed': pressed === undefined ? undefined : !!pressed,
    onKeyDown: (e) => {
        if (disabled || (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar')) {
            return
        }
        e.preventDefault()
        e.stopPropagation()
        onPress(e)
    },
})

// True while the person is typing somewhere (session notes, a search box), so single-letter shortcuts stay out of the way.
export const isTyping = (e) => {
    const t = e.target
    return !!t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))
}
